import { styled } from '@mui/material/styles';

export const StyledSysAidLogo = styled('img')(() => ({
  backgroundColor: 'white',
  padding: 0,
  maxHeight: '27px',
  maxWidth: '150px',
}));

export const StyledSvgLogo = styled('svg')(() => ({
  backgroundColor: 'white',
  padding: 0,
  maxHeight: '27px',
  maxWidth: 'fit-content',
}));
